import styled from 'styled-components'
import { Col, Form, InputGroup, Row } from 'react-bootstrap'

const MOBILE_BP = 767
const DESKTOP_BP = 768

export const FilterRow = styled(Row)`
  @media (min-width: ${DESKTOP_BP}px) {
    gap: 0 !important;
  }
`

export const SearchCol = styled(Col)`
  @media (max-width: ${MOBILE_BP}px) {
    width: 70% !important;
  }
`

export const SearchContainer = styled(InputGroup)`
  width: 100%;
  flex-wrap: nowrap;
`

export const SearchIcon = styled(InputGroup.Text)`
  background-color: var(--white );
  border: none
`

export const SearchInput = styled(Form.Control)`
  height: 2rem;
  width: 86%;
  background-color: var(--white);
  border: none;
  font-size: 0.875rem;
  line-height: 1rem;
  padding: 0.5rem 2rem 0.5rem 0.5rem;
  box-sizing: border-box;

  &:focus {
    outline: none;
    box-shadow: none;
    border: none;
    background-color: var(--white);
  }
`

export const DesktopButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;

  @media (max-width: ${MOBILE_BP}px) {
    display: none;
  }
`

export const MobileButtons = styled.div`
  display: none;
  align-items: center;

  @media (max-width: ${MOBILE_BP}px) {
    display: flex;
    margin-left: 4px;
  }
`
